export default __webpack_public_path__ + "static/media/meir.ce60a3af.png";